import { TeamRepository } from '../repositories';

export class LeaveTeamUseCase {
  constructor(private teamRepository: TeamRepository) {}

  async execute(teamId: string, userId: string, captainId: string): Promise<void> {
    if (userId === captainId) {
      throw new Error('Team captain cannot leave. Delete the team instead.');
    }
    await this.teamRepository.removeMember(teamId, userId);
  }
}
